import { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { api } from '../api';

/* CSS */
import shared from '../styles/shared.module.css';

const JoinTripPage = () => {

    const navigate = useNavigate();

    const { token } = useParams();
    const [error, setError] = useState(null);

    useEffect(() => {
        const joinTrip = async () => {
            try {
                const res = await api.get(`/share/join/${token}`);
                navigate(`/trip/${res.tripId}`, { replace: true });
            } catch (err) {
                setError(err.message || 'Failed to join trip');
            }
        };

        joinTrip();
    }, [token, navigate]);

    if (error) {
        return (
            <div className={shared.authBody}>
                <div className={shared.authTitleWrapper}>
                    <div className={shared.authTitle}>{error}</div>
                    <div className={shared.authSubtitleWrapper}>
                        <Link to="/trips" className={shared.authSubTitleToggle}>Back to My Trips</Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={shared.authBody}>
            <div className={shared.authTitleWrapper}>
                <div className={shared.authTitle}>Joining trip...</div>
                <span className={shared.spinner}></span>
            </div>
        </div>
    );
};

export default JoinTripPage;
